var React = require('react');

function IconListHeader (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M960.2 130H320.1v128h640.1V130zM245 191.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4zM959.2 451H320.1v128h639.1V451zM244 512.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4 91.4 41 91.4 91.4zM959.2 770H320.1v128h639.1V770zM249 832.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4z"}));
}

IconListHeader.displayName = "IconListHeader";

IconListHeader.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconListHeader;

IconListHeader.default = IconListHeader;
